import React from "react";

const MovieNavbar = () => {
  return <div>MovieNavbar</div>;
};

export default MovieNavbar;
